// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-tooltip-main--38rmH","liveTravelTime":"segment-tooltip-liveTravelTime--19AzG","statusText":"segment-tooltip-statusText--2ABhH","speedNumber":"segment-tooltip-speedNumber--10fJR","trendIcon":"segment-tooltip-trendIcon--3JNvf","segment":"segment-tooltip-segment--2x871","segmentIcon":"segment-tooltip-segmentIcon--2xpHB","segmentName":"segment-tooltip-segmentName--3o9Rj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/SegmentTooltip/segment-tooltip.scss
// module id = zHhQ
// module chunks = 4